import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

interface WithdrawalDataPoint {
  year: number;
  // p5: number;
  p10: number;
  // p25: number;
  p50: number;
  // p75: number;
  // p90: number;
  // p95: number;
}

interface WithdrawalChartProps {
  data: WithdrawalDataPoint[];
  isLoading: boolean;
}

const WithdrawalChart: React.FC<WithdrawalChartProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return (
      <div className="chart-container">
        <h2>Annual Withdrawal Amount</h2>
        <div className="loading">Running Monte Carlo simulation...</div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="chart-container">
        <h2>Annual Withdrawal Amount</h2>
        <div className="no-data">Run a simulation to see withdrawal projections</div>
      </div>
    );
  }

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="withdrawal-chart">
      <div className="chart-container">
        <h2>Annual Withdrawal Amount (Inflation-Adjusted)</h2>
        <div className="chart-wrapper">
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="year" 
                label={{ value: 'Year', position: 'insideBottom', offset: -10 }}
              />
              <YAxis 
                width={110}
                tickMargin={8}
                label={{ value: 'Withdrawal Amount', angle: -90, position: 'insideLeft', offset: 0, style: { textAnchor: 'middle' } }}
                tickFormatter={formatCurrency}
              />
              <Tooltip 
                formatter={(value: number, name: string) => [formatCurrency(value), name]}
                labelFormatter={(year) => `Year ${year}`}
              />
              <Legend />
              {/* <Line 
                type="monotone" 
                dataKey="p5" 
                stroke="#ff6b6b" 
                strokeWidth={1}
                strokeDasharray="2 2"
                name="5th Percentile"
                dot={false}
              /> */}
              <Line 
                type="monotone" 
                dataKey="p10" 
                stroke="#ffa726" 
                strokeWidth={1}
                strokeDasharray="2 2"
                name="10th Percentile"
                dot={false}
              />
              {/* <Line 
                type="monotone" 
                dataKey="p25" 
                stroke="#ffeb3b" 
                strokeWidth={2}
                strokeDasharray="4 4"
                name="25th Percentile"
                dot={false}
              /> */}
              <Line 
                type="monotone" 
                dataKey="p50" 
                stroke="#38b2ac" 
                strokeWidth={3}
                name="Median (50th Percentile)"
                dot={false}
              />
              {/* <Line 
                type="monotone" 
                dataKey="p75" 
                stroke="#ffeb3b" 
                strokeWidth={2}
                strokeDasharray="4 4"
                name="75th Percentile"
                dot={false}
              />
              <Line 
                type="monotone" 
                dataKey="p90" 
                stroke="#ffa726" 
                strokeWidth={1}
                strokeDasharray="2 2"
                name="90th Percentile"
                dot={false}
              />
              <Line 
                type="monotone" 
                dataKey="p95" 
                stroke="#ff6b6b" 
                strokeWidth={1}
                strokeDasharray="2 2"
                name="95th Percentile"
                dot={false}
              /> */}
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalChart;
